import React from 'react';
import {
  Box,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { colors, theme } from '../../../utils/theme';
import { ReactComponent as CalendarIcon } from '../../../images/calendar.svg';
import { formatFullDateToString } from '../../../utils';

export const Header = ({
  date,
  title,
}: {
  date: string;
  title: string;
}): JSX.Element => {
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'));

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      flexDirection={isMobile ? 'column' : 'row'}
      alignItems="flex-start"
      sx={{ mb: 1, mt: 4 }}
    >
      <Typography variant="medium" fontSize={26} sx={{ mb: 1 }}>
        {title}
      </Typography>

      <Box
        display="flex"
        flexDirection="column"
        alignItems={isMobile ? 'flex-start' : 'flex-end'}
        sx={{ mt: { xs: 4, md: 0 } }}
      >
        <Typography variant="light" fontSize={14} sx={{ mr: 0.5 }}>
          Your latest test date
        </Typography>
        <Box sx={{ mt: 1 }}>
          <Select
            value={formatFullDateToString(date)}
            autoWidth
            disabled
            MenuProps={{
              sx: {
                '& .MuiPaper-root': {
                  boxShadow: 'none',
                  border: `1px solid ${colors.greys.GREY_300}`,
                  mt: 0.75,
                  color: colors.greys.GREY_500,
                  borderRadius: 1.25,
                  '& .Mui-selected': {
                    background: colors.greys.BASE_WHITE,
                    color: theme.palette.info.main,
                  },
                },
                '& .MuiMenu-list': { py: 0 },
                '& .MuiMenuItem-root': {
                  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                  borderRadius: 1.25,
                  py: 1.25,
                  mb: 0.5,
                  '&:hover': {
                    background: colors.greys.HOVER_GREY,
                    borderRadius: 1.25,
                  },
                  '&:active': {
                    border: `1px solid ${theme.palette.info.main}`,
                  },
                  '&:last-child': { boxShadow: 'none', mb: 0 },
                },
              },
            }}
            sx={{
              width: 146,
              '& .MuiOutlinedInput-notchedOutline': {
                border: `1px solid ${colors.greys.GREY_300}`,
                borderRadius: 1.25,
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                border: `1px solid ${colors.greys.GREY_300}`,
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: `1px solid ${colors.greys.GREY_300}`,
              },
              '& .MuiInputBase-input': {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                pl: 2.25,
                py: 1,
                background: colors.greys.BASE_WHITE,
                color: colors.greys.GREY_500,
              },
              '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
                pr: 2.25,
              },
              '& .MuiSelect-icon': {
                display: 'none',
              },
            }}
          >
            <MenuItem value={formatFullDateToString(date)} disableRipple>
              <CalendarIcon />
              <Typography fontSize={14} sx={{ ml: 1 }}>
                {formatFullDateToString(date)}
              </Typography>
            </MenuItem>
          </Select>
        </Box>
      </Box>
    </Box>
  );
};
